export default __webpack_public_path__ + "static/media/icons-trip-48-px.444d0ccb.svg";